<template>
  <div>
    <div v-if="type == 'view'" class="ec-form--view">
      {{ displayVal ? displayVal && displayVal.label : defaultVal }}
    </div>
    <treeselect
      v-else
      class="ec-treeselect"
      v-model="currentModelKey"
      :options="optionsList"
      :placeholder="placeholder"
      @select="select"
    />
  </div>
</template>
<script>
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "EcTreeselect",
  props: {
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterKey: {
      type: String,
      default: "",
    },
    filterValue: {
      type: String,
      default: "",
    },
    defaultVal: {
      type: String,
      default: "",
    },
    placeholder: {
      default: this.defaultTip,
      type: String,
    },
    modelKey: {
      type: String,
    },
    valueKey: {
      //字段名称
      type: String,
    },
    getData: {
      //获取待选数据集方法
      type: Function,
    },
    params: {
      //获取待选数据集方法的参数
      type: Object,
    },
    isGetSelectIds: {
      type: Boolean,
      default: false,
    },
    correspond: {
      //外部定义option组件获取value字段名和label字段名，格式：:correspond={'value':'字段名','label':'字段名'}
      type: Object,
    },
    url: {
      type: String,
    },
    isGetData: {
      default: true,
      type: Boolean,
    },
  },
  inject: {
    elForm: {
      default: "",
    },
  },
  computed: {
    type() {
      return (
        (this.elForm && this.elForm.$attrs && this.elForm.$attrs.type) || ""
      );
    },
    displayVal() {
      if (this.type == "view") {
        let optionsList = this.optionsList;
        return this.depthSearch(optionsList);
      }
      return "";
    },
  },
  data() {
    return {
      optionsList: [],
      defaultTip: this.$t("table.choose"),
      tempModelKey: this.modelKey,
      selectIds: [],
      currentModelKey: this.modelKey,
    };
  },
  components: {
    treeselect,
  },
  watch: {
    //判断下拉框的值是否有改变
    modelKey: function (newValue, oldValue) {
      this.currentModelKey = newValue;
    },
    currentModelKey(val, oldVal) {
      if (val != oldVal) {
        //将数据返回给父组件
        this.$emit("treeSelect", this.valueKey, val);
      }
    },
  },
  methods: {
    filterData(data) {
      let _this = this;
      let newData = [];
      if (_this.isFilter) {
        if (data.length <= 0) {
          return [];
        }
        data.forEach((item) => {
          if (item[_this.filterKey] + "" === _this.filterValue) {
            if (item.children) {
              item.children = _this.filterData(item.children);
              if (item.children.length == 0) {
                item.children = null;
              }
            }
            newData.push(item);
          }
        });
        //  newData = data.filter(function (item) {
        //   if(item[_this.filterKey]+''==_this.filterValue){
        //     if (item.children) {
        //       item.children = _this.filterData(item.children);
        //     }
        //     return item;
        //   }
        // })
      } else {
        newData = data;
      }
      return newData;
    },
    concatData(data, params) {
      if (data.length <= 0) {
        return [];
      }
      let [key, ...restValue] = [...params];
      data.forEach((item) => {
        let str = "";
        restValue.forEach((subItem) => {
          str += item[subItem];
        });
        item[key] = str;
        if (item.children) {
          this.concatData(item.children, params);
        }
      });
      return data;
    },
    depthSearch(data) {
      var result = null;
      data.forEach((item) => {
        if (item[this.correspond.value] == this.currentModelKey) {
          result = item;
          return result;
        } else if (item.children && item.children !== "undefined") {
          let res = this.depthSearch(item.children);
          if (res) {
            result = res;
          }
        }
      });
      return result;
    },
    async initOptionsList() {
      let _this = this;
      if (_this.modelKey == "") {
        _this.currentModelKey = null;
      }
      let valueArr = _this.correspond.value
        .split(",")
        .map((item) => item.trim());
      let labelArr = _this.correspond.label
        .split(",")
        .map((item) => item.trim());
      valueArr.unshift("id");
      labelArr.unshift("label");
      let _data = {};
      if (_this.isGetData) {
        //判断是否为报表配置中配置的下拉框
        const { data } = await _this.getData(_this.params);
        _data = data;
      } else {
        const { data } = await _this.Api["reportSelect"](_this.url);
        _data = data;
      }
      let resData = _this.filterData(_data.list);
      _this.concatData(_this.concatData(resData, labelArr), valueArr);
      let dataS = JSON.stringify(resData)
        /*tree-select 0.38版本对于children为null的节点需要自定义loadOptions方法来实现子节点的延迟加载；
             如果要声明叶子节点，请设置children: undefined或省略此属性；
            由于数据已全部加载，故在此将children的null值替换为undefined
            api地址：https://vue-treeselect.js.org/ */
        .replace(/null/g, '"undefined"');
      _this.optionsList = JSON.parse(dataS);
    },
    select(node) {
      let _this = this;
      _this.selectIds = [];
      if (_this.isGetSelectIds) {
        _this.deepTraversal(node);
        _this.$emit("getSelectIds", _this.selectIds);
      }
    },
    deepTraversal(node) {
      let _this = this;
      if (node != null) {
        _this.selectIds.push(node.id);
        if (node.children) {
          let childrens = node.children;
          for (let i = 0; i < childrens.length; i++) {
            _this.deepTraversal(childrens[i]);
          }
        }
      }
    },
  },
  mounted() {
    let _this = this;
    _this.initOptionsList();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/EcTreeselect/src/treeselect.vue